module.exports = __webpack_public_path__ + "static/media/me.ff673120.jpeg";